var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 3.09375V2.34375C13.1875 1.05141 12.1361 0 10.8438 0H5.09375C3.80141 0 2.75 1.05141 2.75 2.34375V3.09375H13.1875Z",
    fill: "#052987"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6875 9.96875V13.7812V14.5938V15.0625C3.6875 15.5802 4.10722 16 4.625 16H11.3125C11.8303 16 12.25 15.5802 12.25 15.0625V14.5938V13.7812V9.96875H3.6875ZM9.21875 13.9688H6.71875C6.45988 13.9688 6.25 13.7589 6.25 13.5C6.25 13.2411 6.45988 13.0312 6.71875 13.0312H9.21875C9.47762 13.0312 9.6875 13.2411 9.6875 13.5C9.6875 13.7589 9.47762 13.9688 9.21875 13.9688ZM9.21875 11.9688H6.71875C6.45988 11.9688 6.25 11.7589 6.25 11.5C6.25 11.2411 6.45988 11.0312 6.71875 11.0312H9.21875C9.47762 11.0312 9.6875 11.2411 9.6875 11.5C9.6875 11.7589 9.47762 11.9688 9.21875 11.9688Z",
    fill: "#052987"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 4.03125H2.34375C1.05141 4.03125 0 5.08266 0 6.375V10.125C0 11.4173 1.05141 12.4688 2.34375 12.4688H2.75V9.96875H2.46875C2.20988 9.96875 2 9.75887 2 9.5C2 9.24113 2.20988 9.03125 2.46875 9.03125H3.21875H12.7188H13.4688C13.7276 9.03125 13.9375 9.24113 13.9375 9.5C13.9375 9.75887 13.7276 9.96875 13.4688 9.96875H13.1875V12.4688H13.625C14.9173 12.4688 15.9688 11.4173 15.9688 10.125V6.375C15.9688 5.08266 14.9173 4.03125 13.625 4.03125ZM3.96875 6.96875H2.46875C2.20988 6.96875 2 6.75887 2 6.5C2 6.24113 2.20988 6.03125 2.46875 6.03125H3.96875C4.22762 6.03125 4.4375 6.24113 4.4375 6.5C4.4375 6.75887 4.22762 6.96875 3.96875 6.96875Z",
    fill: "#052987"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterBlue);
export default __webpack_public_path__ + "static/media/printer-blue.137f09d5b6002d5f90ece6e214875b79.svg";
export { ForwardRef as ReactComponent };